import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useState, useEffect } from "react";
import { loginRequest , graphConfig } from "../environments/environments";

const useUserPicture = () => {
    const { instance, accounts } = useMsal();
    const account = accounts && accounts[0];
    const [imageUrl, setImageUrl]:any = useState(null);

    const fetchUserProfilePicture = (token: string)=> {
        axios
          .get(graphConfig.graphMeEndpoint, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          })
          .then((o: any) => {
            const url = window.URL || window.webkitURL;
            const blobUrl = url.createObjectURL(o.data);
            setImageUrl(blobUrl);
          });
    }

    
  useEffect(() => {
    const request = { ...loginRequest, account };
    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        fetchUserProfilePicture(response.accessToken);
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
            fetchUserProfilePicture(response.accessToken);
        });
      });
  }, []);



  return { imageUrl };
};

export default useUserPicture;
